import { render, staticRenderFns } from "./RegistryFormTab.vue?vue&type=template&id=79ca4752"
import script from "./RegistryFormTab.vue?vue&type=script&lang=js"
export * from "./RegistryFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports